import { AuthenticatedUser } from "@biggeo/bg-server-lib/studio";
import { Grid, Hidden, IconButton } from "@biggeo/bg-ui/lab";
import { MenuOutline } from "@biggeo/bg-ui/lab/icons";
import { AccountMenuContainer } from "../common/containers/AccountMenuContainer";

export type AuthedHeaderProps = Readonly<{
    openSidebar?: () => void;
    user: AuthenticatedUser;
}>;

export const AuthedHeader = ({ user, openSidebar }: AuthedHeaderProps) => {
    return (
        <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            minHeight={9}
        >
            <Grid item>
                <Grid display="flex" alignItems="stretch" gap={2}>
                    <Hidden variant="up" item>
                        <IconButton
                            variant="outlined"
                            density="dense"
                            onClick={openSidebar}
                        >
                            <MenuOutline size="xs" />
                        </IconButton>
                    </Hidden>
                    {/* <BigGeoLink href="" tabIndex={-1}>
                        <Button
                            variant="outlined"
                            startNode={<DatascapeIcon />}
                            sx={{
                                borderRadius: (theme) => theme.radius.full,
                            }}
                            density="dense"
                        >
                            Upgrade Plan
                        </Button>
                    </BigGeoLink> */}
                </Grid>
            </Grid>
            {user && (
                <Grid item>
                    <Grid display="flex" alignItems="stretch" gap={2}>
                        {/* <Badge label={3} color="error">
                            <NotificationMenu notifications={[]}>
                                <IconButton variant="outlined" density="dense">
                                    <NotificationsOutline size="xs" />
                                </IconButton>
                            </NotificationMenu>
                        </Badge> */}
                        <AccountMenuContainer authUser={user} />
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};
